import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ButtonsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '20px',
  width: '100%',

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export const ContentText = styled(Typography)(() => ({
  marginBottom: '30px',
  alignSelf: 'flex-start',

  span: {
    fontWeight: 600,
  },
}));
